/* eslint-disable array-callback-return */
// import { queryHelpers } from '@testing-library/dom'
import React from 'react'
import { useQuery } from '../../utils/App'
import { CreationHotel } from '../Admin/Hotel/EditHotel'
import { AddProperty } from './AddProperty'
// import { AddPropertyHotel } from './AddPropertyHotel'
export const AddPropertyCondition = () => {
    const query=useQuery()
    return (
        <>
            {
                query.get('ajout')==="Hôtel"? <CreationHotel/> : <AddProperty/>
            }
        </>
    )
} 